import { ReactNode } from "react";
import {
  Button,
  Card,
  CircularProgress,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmModalProps {
  open: boolean;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  confirmColor?: "primary" | "error" | "warning";
  confirmIcon?: ReactNode;
  confirming?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmModal = ({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  confirmColor = "primary",
  confirmIcon,
  confirming = false,
  onClose,
  onConfirm,
}: ConfirmModalProps) => (
  <Modal open={open} onClose={onClose}>
    <Stack height="100%" alignItems="center" justifyContent="center">
      {/* 600px is the design width; the cap keeps the card — and with it the
          copy naming what is about to be deleted — inside a narrow viewport,
          which a fixed width clips on both sides. */}
      <Box sx={{ width: 600, maxWidth: "calc(100% - 32px)" }}>
        <Card>
          <Typography
            variant="h5"
            component="h5"
            align="center"
            sx={{ paddingTop: 1 }}
          >
            {title}
          </Typography>
          {description && (
            <Box
              display="flex"
              justifyContent="center"
              sx={{ paddingX: 4, paddingY: 2 }}
            >
              <Typography align="center" component="div">
                {description}
              </Typography>
            </Box>
          )}
          <Box display="flex">
            <Button
              startIcon={<CloseIcon />}
              fullWidth
              sx={{ marginX: 4, marginY: 1 }}
              color="primary"
              onClick={onClose}
              disabled={confirming}
            >
              Cancel
            </Button>
            <Button
              startIcon={
                confirming ? <CircularProgress size={16} /> : confirmIcon
              }
              fullWidth
              sx={{ marginX: 4, marginY: 1 }}
              color={confirmColor}
              onClick={onConfirm}
              disabled={confirming}
            >
              {confirmLabel}
            </Button>
          </Box>
        </Card>
      </Box>
    </Stack>
  </Modal>
);
